const scrollTo = (timeout = 100, top = 0) => {
  setTimeout(() => {
    window.scrollTo({
      top: top,
      behavior: 'smooth'
    });
  }, timeout);
};

export default scrollTo;
